export default __webpack_public_path__ + "static/media/no.7778e272.png";